package com.milta.core.localization.translations.es

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Cuota de optimizaciones alcanzada",
    exhaustedCreateRouteMessage = "Disponible de nuevo el {date}. Puede crear la ruta sin optimización: se conserva el orden introducido.",
    exhaustedCreateBatchMessage = "De nuevo {limit} optimizaciones el {date}. El lote puede crearse sin optimización: se conserva el orden introducido.",
    quotaReachedResetOn = "Cuota de optimizaciones alcanzada — se reinicia el {date}",
    routeCreatedInEnteredOrder = "Ruta creada en el orden introducido.",
    routeWillBeCreatedInEnteredOrder = "La ruta se creará en el orden introducido.",
    batchCreatedInEnteredOrder = "El lote se ha creado sin optimización, en el orden introducido.",
    sendWithoutOptimization = "Enviar sin optimización",
    batchNotOptimizedTitle = "Lote creado sin optimización",
    batchNotOptimizedMessage = "Cuota de optimizaciones alcanzada. Se conserva el orden actual de las paradas.",
    batchNotOptimizedMobileMessage = "Lote creado sin optimización: cuota de optimizaciones alcanzada. Orden introducido conservado, paradas repartidas equitativamente.",
    reoptimizeAction = "Reoptimizar",
    reoptimizeUnavailableWeb = "Reoptimización no disponible: cuota alcanzada, de nuevo el {date}. Se conserva el orden actual y el envío sigue siendo posible.",
    reoptimizeUnavailableMobile = "Reoptimización no disponible hasta el {date} (cuota alcanzada). El envío sigue siendo posible.",
    stopAddedAtEndTitle = "Parada añadida al final de la ruta",
    stopAddedAtEndMessage = "Cuota de optimizaciones alcanzada — se reinicia el {date}. El orden de las demás paradas no cambia.",
    reoptimizeExhaustedHint = "Cuota de optimizaciones alcanzada, de nuevo el {date}",
    myOptimizationsTitle = "Mis optimizaciones",
    remainingForPeriod = "Restante en el periodo",
    remainingSuffix = "restantes",
    resetLabel = "Reinicio",
    resetAtRenewal = "Al renovarse la suscripción",
    driverExplanation = "Se reinicia al renovarse su suscripción. Conductor de una Empresa: su contador sigue la suscripción de la Empresa, con el límite de prueba mientras esté en prueba.",
    enterpriseExplanation = "Se reinicia al renovarse su suscripción. Este contador solo cubre sus propias optimizaciones; cada conductor tiene el suyo.",
    webCounterNotice = "Este contador solo cubre las optimizaciones lanzadas por esta cuenta. Cada conductor tiene el suyo, visible en su app.",
    historyTitle = "Historial",
    columnDate = "Fecha",
    columnAction = "Acción",
    columnTarget = "Ruta afectada",
    columnOutcome = "Resultado",
    actionOptimizeRoute = "Optimizar una ruta",
    actionCreateRouteBatch = "Crear un lote",
    actionReoptimizeRouteBatch = "Reoptimizar un lote",
    actionReoptimizeOnStopAdded = "Reoptimizar al añadir una parada",
    actionReoptimizeInPlace = "Reoptimizar sobre la marcha",
    actionCreateOwnRoute = "Crear mi ruta",
    outcomeCounted = "Contada",
    outcomeRefunded = "Devuelta",
    outcomeRefundedLong = "Devuelta — fallo de RoutaR",
    refundedNotCounted = "fallo de RoutaR, no contada",
    targetRoute = "Ruta del {date}",
    targetBatch = "Lote del {date}",
    historyLoadingMore = "Cargando las líneas siguientes…",
    historyEnd = "Fin del historial — {count} líneas",
    historyEmpty = "Ninguna optimización en este periodo.",
    historyLoadError = "No se pudo cargar el historial.",
    retryAction = "Reintentar",
    loading = "Cargando…",
    errorNoConnection = "No se puede contactar con el servidor — compruebe su conexión.",
    errorGeneric = "Se ha producido un error. Inténtelo más tarde.",
    tabOptimizations = "Optimizaciones RoutaR",
    tabAiTokens = "Tokens de IA",
    comingSoon = "Próximamente",
    limitsDescription = "Número de optimizaciones RoutaR permitidas por cuenta y por periodo de suscripción, según el tipo de cuenta y el estado de la suscripción. El contador de cada cuenta se reinicia al renovarse su suscripción.",
    columnTrial = "Prueba",
    columnPaid = "De pago",
    rowEnterprise = "Cuenta Empresa",
    rowDriver = "Conductor",
    fieldRequired = "Campo obligatorio.",
    fieldMustBePositive = "Debe ser mayor que 0.",
    limitsFootnote = "Valores en optimizaciones por periodo. Un conductor de una Empresa recibe el límite «Conductor», de prueba mientras su Empresa esté en prueba, si no de pago.",
    limitsSaved = "Límites guardados. Empresa: {enterpriseTrial} prueba · {enterprisePaid} de pago. Conductor: {driverTrial} prueba · {driverPaid} de pago.",
    limitsRejected = "Valores rechazados: cada límite debe ser mayor que 0.",
    saveAction = "Guardar",
    detailsAction = "Detalles",
    accountDetailsTitle = "Detalles del usuario",
    sectionIdentity = "Identidad",
    accountTypeLabel = "Tipo de cuenta",
    kindEnterpriseOwner = "Cuenta Empresa",
    kindEnterpriseDriver = "Conductor de Empresa",
    kindIndependentDriver = "Conductor independiente",
    withoutOrganisation = "Sin organización",
    subscriptionLabel = "Suscripción",
    viaOrganisation = "Vía organización",
    subscriptionTrial = "Prueba",
    subscriptionPaid = "De pago",
    appliedLimitLabel = "Límite aplicado",
    limitKindEnterprise = "Límite Cuenta Empresa",
    limitKindDriver = "Límite Conductor",
    enterpriseInTrialSuffix = "(la Empresa está en prueba)",
    resetSourceOwn = "Renovación de la suscripción",
    resetSourceEnterprise = "Renovación de {enterprise}",
    exhaustedBadge = "Cuota agotada",
    manuallyAdjustedBadge = "Sustituido manualmente",
    replaceLabel = "Sustituir el número restante",
    replaceAction = "Sustituir",
    replaceHelp = "Solo para el periodo actual. En el reinicio, la cuenta vuelve a partir del límite global.",
    replaceHelpEnterpriseDriver = "Solo modifica el contador de {name}. El de la Empresa y el de los demás conductores no cambia.",
    replaceInvalid = "Introduzca un número mayor o igual que 0.",
    replaceRejected = "Valor rechazado por el servidor.",
    replaceMaximum = "Máximo 100.000.",
    replacedBanner = "Número restante sustituido: {from} → {to}. Para el periodo actual. El {date}, vuelta al límite global ({limit}).",
    adminHistoryTitle = "Historial de optimizaciones",
    accountNotFound = "Cuenta no encontrada.",
)
